// JobApplicationDetailsReducer.ts
import { JobApplicationDetailsState } from './JobApplicationDetailsState';
import { Application } from '../../jobApplications/model/JobApplicationsModel';

export type Action =
  | { type: 'FETCH_START' }
  | { type: 'FETCH_SUCCESS'; payload: Application }
  | { type: 'FETCH_ERROR'; payload: string }
  | { type: 'WITHDRAW_START' }
  | { type: 'WITHDRAW_SUCCESS'; payload: Application }
  | { type: 'WITHDRAW_ERROR'; payload: string }
  | { type: 'DOWNLOAD_START' }
  | { type: 'DOWNLOAD_SUCCESS' }
  | { type: 'DOWNLOAD_ERROR'; payload: string }
  | { type: 'ADD_TOAST'; payload: { message: string; type: 'success' | 'error' | 'info' | 'warning' } }
  | { type: 'REMOVE_TOAST'; payload: number }
  | { type: 'CLEAR_TOASTS' }
  | { type: 'CLEAR_ERROR' };

export const reducer = (
  state: JobApplicationDetailsState,
  action: Action
): JobApplicationDetailsState => {
  switch (action.type) {
    case 'FETCH_START':
      return { ...state, loading: true, error: null };

    case 'FETCH_SUCCESS':
      return { ...state, loading: false, application: action.payload };

    case 'FETCH_ERROR':
      return { ...state, loading: false, error: action.payload };

    case 'WITHDRAW_START':
      return { ...state, withdrawLoading: true };

    case 'WITHDRAW_SUCCESS':
      return { ...state, withdrawLoading: false, application: action.payload };

    case 'WITHDRAW_ERROR':
      return { ...state, withdrawLoading: false, error: action.payload };

    case 'DOWNLOAD_START':
      return { ...state, downloadLoading: true };

    case 'DOWNLOAD_SUCCESS':
      return { ...state, downloadLoading: false };

    case 'DOWNLOAD_ERROR':
      return { ...state, downloadLoading: false, error: action.payload };

    case 'ADD_TOAST':
      const newToast = {
        id: Date.now(),
        message: action.payload.message,
        type: action.payload.type,
      };
      return { ...state, toasts: [...state.toasts, newToast] };

    case 'REMOVE_TOAST':
      return { ...state, toasts: state.toasts.filter(toast => toast.id !== action.payload) };

    case 'CLEAR_TOASTS':
      return { ...state, toasts: [] };

    case 'CLEAR_ERROR':
      return { ...state, error: null };

    default:
      return state;
  }
};